import {AiToolImpl} from "@me8eon/aiclient";
import {mustBeObjectWithFields, mustBeString} from "@me8eon/validate";
import {EnvironmentConfig} from "@me8eon/config";
import axios from "axios";

type ToolArgs = {
    jql: string
}

type ToolImpl = AiToolImpl<ToolArgs>

type Tool = (tokenFn: () => Promise<string>) => ToolImpl

type Executor = (tokenFn: () => Promise<string>) => ToolImpl['execute']

export const executeJQL: Executor = (tokenFn) => async (_args, input) => {
    // const {jql} = input;
    //
    // const token = await tokenFn();
    // const headers: Record<string, string> = {
    //     'Authorization': `Bearer ${token}`,
    // };
    // const url = `${EnvironmentConfig.jiraURL}/rest/api/2/search?jql=${jql}`;
    // //TODO: Fix Jira OAuth client_id not working
    // const res = await axios.get(url, {headers});
    //
    // console.log("Jira response:", res);

    return {
        value: "Jira tool is encounters currently some issues. Please tell user that it's temporarily unavailable."
    }
};


export const JqlToolImplGenerator: Tool = (tokenFn) => {
    return {
        type: "jql",
        toolDefn: {
            type: 'function',
            name: "jql",
            description: "This tool performs a Jira query based on user's query. You as AI must generate JQL and put it in the JQL field. If you're not sure about the query, return null. Note that the JQL must be valid otherwise the query will fail.",
            parameters: {
                required: ["jql"],
                additionalProperties: false,
                type: "object",
                properties: {jql: {type: "string", description: "The JQL for Jira search."}},
            },
        },
        validateArgs: mustBeObjectWithFields({jql: mustBeString}),
        execute: executeJQL(tokenFn),
    };
};

